import { apiFetch } from './client';

// Phase 3 — Agent Template System.
//
// * templatesApi      : full admin surface (list/create/read/update/publish/archive/delete).
// * agentCompilerApi  : admin compile + preview + compilation history.
// * dealerAgentApi    : dealer-safe agent card (zero prompt text).
//
// All admin endpoints require a platform_admin token. The server refuses
// to return prompt content to any non-admin caller; the dealer card is
// the only safe endpoint a tenant user should ever call for this data.
export const templatesApi = {
  list: (params) => apiFetch('/api/agent-templates', { params }),
  get: (id) => apiFetch(`/api/agent-templates/${id}`),
  create: (payload) =>
    apiFetch('/api/agent-templates', { method: 'POST', body: payload }),
  update: (id, payload) =>
    apiFetch(`/api/agent-templates/${id}`, { method: 'PATCH', body: payload }),
  publish: (id) =>
    apiFetch(`/api/agent-templates/${id}/publish`, {
      method: 'POST',
      body: {},
    }),
  archive: (id) =>
    apiFetch(`/api/agent-templates/${id}/archive`, {
      method: 'POST',
      body: {},
    }),
  remove: (id) =>
    apiFetch(`/api/agent-templates/${id}`, { method: 'DELETE' }),
  compilations: (id, limit = 20) =>
    apiFetch(`/api/agent-templates/${id}/compilations`, {
      params: { limit },
    }),
};

export const agentCompilerApi = {
  compile: (payload) =>
    apiFetch('/api/agent-compiler/compile', {
      method: 'POST',
      body: payload,
    }),
  preview: (payload) =>
    apiFetch('/api/agent-compiler/preview', {
      method: 'POST',
      body: payload,
    }),
  getCompilation: (id) =>
    apiFetch(`/api/agent-compiler/compilations/${id}`),
  latestForDealer: (dealerId) =>
    apiFetch(`/api/agent-compiler/dealers/${dealerId}/latest`),
};

export const dealerAgentApi = {
  // Returns ONLY the safe card view — never prompt text or brief content.
  getCard: (dealerId) =>
    apiFetch('/api/dealer/agent-card', {
      params: dealerId ? { dealer_id: dealerId } : undefined,
    }),
};
